var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sklib-layout"},[_c('SklibHeaderVue'),_c('main',{staticClass:"sklib-main"},[_c('router-view')],1),_c('SklibFooterVue'),_c('el-backtop',{attrs:{"target":".sklib-main","right":16,"bottom":8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }